import useActiveWeb3 from 'hooks/blockchain/useActiveWeb3'
import useBlockNumber from 'hooks/blockchain/useBlockNumber'
import multicall from 'state/transactions/multicall'
import { SkipFirst } from 'utils/tuple'

export type { CallStateResult } from '@uniswap/redux-multicall' // re-export for convenience
export { NEVER_RELOAD } from '@uniswap/redux-multicall' // re-export for convenience

// Create wrappers for hooks so consumers don't need to get latest block themselves

type SkipFirstTwoParams<T extends (...args: any) => any> = SkipFirst<Parameters<T>, 2>

export function useMultipleContractSingleData(
  ...args: SkipFirstTwoParams<typeof multicall.hooks.useMultipleContractSingleData>
) {
  const { networkId, latestBlock } = useCallContext()
  return multicall.hooks.useMultipleContractSingleData(networkId, latestBlock, ...args)
}

export function useSingleCallResult(...args: SkipFirstTwoParams<typeof multicall.hooks.useSingleCallResult>) {
  const { networkId, latestBlock } = useCallContext()
  return multicall.hooks.useSingleCallResult(networkId, latestBlock, ...args)
}

export function useSingleContractMultipleData(
  ...args: SkipFirstTwoParams<typeof multicall.hooks.useSingleContractMultipleData>
) {
  const { networkId, latestBlock } = useCallContext()
  return multicall.hooks.useSingleContractMultipleData(networkId, latestBlock, ...args)
}

export function useSingleContractWithCallData(
  ...args: SkipFirstTwoParams<typeof multicall.hooks.useSingleContractWithCallData>
) {
  const { networkId, latestBlock } = useCallContext()
  return multicall.hooks.useSingleContractWithCallData(networkId, latestBlock, ...args)
}

function useCallContext() {
  const { networkId } = useActiveWeb3()
  const latestBlock = useBlockNumber()
  return { networkId, latestBlock }
}
